module.exports = __webpack_public_path__ + "static/accounts_2-6f4026b88c129fb39a15ef3b1fcec300.png";